import { BoxProps, TextProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const styles = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    flex: 1,
    backgroundColor: 'WHITE',
    marginHorizontal: 16,
    padding: 16,
    borderRadius: 8,
    position: 'relative',
    overflow: 'auto',
  } as BoxProps,
  dateContainer: {
    borderWidth: 1,
    flex: 1,
    flexDirection: 'row',
    align: 'center',
    borderColor: 'TRANSPARENT',
  } as BoxProps,
  flexRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  } as BoxProps,
  listContainer: {
    borderWidth: 1,
    borderColor: 'BORDER_PRIMARY',
    p: 16,
    borderRadius: 4,
    minHeight: 450,
  } as BoxProps,
  graphView: {
    container: {
      flex: 1,
      backgroundColor: 'WHITE',
      // marginHorizontal: 16,
      // padding: 16,
      borderWidth: 1,
      borderColor: 'BORDER_COLOR',
      borderRadius: 8,
      position: 'relative',
    } as BoxProps,
    dateContainer: {
      // borderWidth: 1,
      flex: 1,
      flexDirection: 'row',
      align: 'center',
      // borderColor: 'TRANSPARENT',
    } as BoxProps,
    flexRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-evenly',
    } as BoxProps,
    listContainer: {
      borderWidth: 1,
      borderColor: 'BORDER_PRIMARY',
      p: 16,
      borderRadius: 4,
      flexDirection: 'column',
      minHeight: 400,
    } as BoxProps,
    tittleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: 20,
    } as BoxProps,
    circle: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: 'BLUE',
    } as BoxProps,
    tittle: {
      fontSize: 12,
      textAlign: 'auto',
      color: 'MEDIUM_GREY',
      fontFamily: 'jiotype-medium',
    } as TextProps,
    lineContainer: {
      flexDirection: 'row',
      marginBottom: 20,
      marginLeft: 60,
      marginRight: 20,
      height: 1,
      justifyContent: 'center',
      alignItems: 'center',
    } as BoxProps,
  },
  dotView: {
    height: 8,
    width: 8,
    borderRadius: 4,
    marginHorizontal: 8,
  } as BoxProps,
}

export default styles
